export function Logo() {
  return <h1 className="logo">🌴 Far Away 💼</h1>;
}
